import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import RewardEntryPage from "./pages/Rewards/RewardEntryPage";

const isAuthenticated = () => {
  return localStorage.getItem("token") !== null;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/reward-entry"
          element={
            <RewardEntryPage />
          }
        />
        <Route
          path="*"
          element={
            <Navigate to="/reward-entry" />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
